import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import LoginRegisterModal from './LoginRegisterModal';
import './Header.css';
import { useAuth } from '../context/AuthContext';

function Header() {
  const { user } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const headerRef = useRef(null);

  useEffect(() => {
    const setHeight = () => {
      if (headerRef.current) {
        // Use offsetHeight so placeholder exactly matches header visual height.
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };
    // initial measure + on resize
    setHeight();
    window.addEventListener('resize', setHeight);
    return () => window.removeEventListener('resize', setHeight);
  }, []);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // close mobile menu when going to desktop size
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 992) setIsMobileMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      alert('You have been logged out successfully.');
      if (isMobileMenuOpen) setIsMobileMenuOpen(false);
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openMobileMenu = () => setIsMobileMenuOpen(true);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleMobileLoginClick = () => {
    closeMobileMenu();
    openModal();
  };

  return (
    <>
      <header
        ref={headerRef}
        id="header"
        className={`header ${isScrolled ? 'scrolled' : ''}`}
      >
        <div className="header-top-section">
          <div className="container">
            <div className="header-top" />
          </div>
        </div>

        <div className="desktop-nav">
          <div className="container">
            <div className="header-nav-container">
              <Link to="/" className="logo">
                <img src="/assets/images/logos/toven.png" alt="logo" />
              </Link>
              <div className="nav-and-auth">
                <nav className="header-nav-menu">
                  <ul className="menu-list">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About</Link></li>
                    {user && <li><Link to="/user-dashboard">User Dashboard</Link></li>}
                    <li><Link to="/contact">Contact</Link></li>
                    {/* Desktop Buttons */}
                    <li><Link to="/party-orders" className="btn-nav btn-nav-primary">Party Orders</Link></li>
                    <li><Link to="/addons" className="btn-nav btn-nav-primary">Add On</Link></li>
                    <li><Link to="/package" className="btn-nav btn-nav-secondary">Subscription</Link></li>
                  </ul>
                </nav>
                <div className="auth-controls">
                  {user ? (
                    <div className="logged-in-controls">
                      <span className="welcome-text">
                        {`Welcome, ${user.name || (user.email ? user.email.split('@')[0] : 'User')}`}
                      </span>
                      <button onClick={handleLogout} className="auth-btn logout">Logout</button>
                    </div>
                  ) : (
                    <button onClick={openModal} className="auth-btn login">Login</button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mobile-header">
          <Link to="/" className="mobile-logo">
            <img src="/assets/images/logos/toven.png" alt="logo" />
          </Link>
          <button className="hamburger-btn" type="button" onClick={openMobileMenu}>
            <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="20" height="2" fill="#1D1D1D"></rect>
              <rect y="12" width="20" height="2" fill="#1D1D1D"></rect>
              <rect y="6" width="14" height="2" fill="#1D1D1D"></rect>
            </svg>
          </button>
        </div>

        {isMobileMenuOpen && (
          <>
            <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
            <div className="mobile-menu-drawer">
              <div className="mobile-menu-drawer-header">
                <h5>Menu</h5>
                <button onClick={closeMobileMenu} className="btn-close">✕</button>
              </div>
              <ul className="mobile-menu-list">
                <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
                <li><Link to="/about" onClick={closeMobileMenu}>About</Link></li>
				<li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
                {user && <li><Link to="/user-dashboard" onClick={closeMobileMenu}>User Dashboard</Link></li>}
				<li><Link to="/package" onClick={closeMobileMenu} className="btn-nav btn-nav-secondary">Subscription</Link></li>
				<li><Link to="/addons" onClick={closeMobileMenu} className="btn-nav btn-nav-primary">Add-On's</Link></li>
                
                <li><Link to="/party-orders" onClick={closeMobileMenu} className="btn-nav btn-nav-primary">Party Orders</Link></li>
                
                
              </ul>
              <div className="mobile-auth-controls">
                {user ? (
                  <>
                    <span className="welcome-text">
                      {`Welcome, ${user.name || (user.email ? user.email.split('@')[0] : 'User')}`}
                    </span>
                    <button onClick={handleLogout} className="auth-btn logout w-100">Logout</button>
                  </>
                ) : (
                  <button onClick={handleMobileLoginClick} className="auth-btn login w-100">Login</button>
                )}
              </div>
            </div>
          </>
        )}
      </header>

      {/* placeholder to keep content from hiding under fixed header */}
      <div
        className="header-placeholder"
        style={{ height: headerHeight ? `${headerHeight}px` : '0px' }}
      />

      {isModalOpen && <LoginRegisterModal onClose={closeModal} />}
    </>
  );
}

export default Header;
